import LinkToStripeButton from "../../../../common/LinkToStripeButton";
import { useClientDetails } from "../../../context/clientDetailsContext";

const LinkClientToStripeButton = () => {
  const { linkToStripe } = useClientDetails();

  return (
    <LinkToStripeButton
      handleClick={linkToStripe.link}
      loading={linkToStripe.loading}
    />
  );
};

export default LinkClientToStripeButton;
